// Checkin's embed is a React app. Do not move, hide, rewrite, or observe
// nodes inside #checkin_registration. That desyncs React's tree and crashes
// checkout with: Failed to execute 'removeChild' on 'Node'.
